"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MeetingParticipantRolesSchema () {
        return MeetingParticipantRolesSchema;
    },
    get MeetingParticipantsExtendedSchema () {
        return MeetingParticipantsExtendedSchema;
    },
    get MeetingParticipantsSchema () {
        return MeetingParticipantsSchema;
    },
    get MeetingStatusSchema () {
        return MeetingStatusSchema;
    },
    get MeetingsExportSchema () {
        return MeetingsExportSchema;
    },
    get MeetingsExtendedSchema () {
        return MeetingsExtendedSchema;
    },
    get MeetingsSchema () {
        return MeetingsSchema;
    },
    get SLOT_HOLDING_MEETING_STATUSES () {
        return SLOT_HOLDING_MEETING_STATUSES;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _base = require("../base");
const _calendarevent = require("../calendar-event");
const _useractionrecord = require("../shared/user-action-record");
const _videoconference = require("../video-conference");
const MeetingStatusSchema = _zod.z.enum([
    "active",
    "archived",
    "canceled",
    "completed"
]).default("active");
const SLOT_HOLDING_MEETING_STATUSES = [
    "active",
    "completed"
];
const MeetingParticipantRolesSchema = _zod.z.literal("editor");
const MeetingParticipantsSchema = _zod.z.object({
    role: MeetingParticipantRolesSchema,
    /** Foreign key - user document */ user_id: _zod.z.instanceof(_bson.ObjectId)
});
const MeetingParticipantsExtendedSchema = MeetingParticipantsSchema.extend({
    name: _zod.z.string()
});
const MeetingsSchema = _base.BaseDocument.extend({
    /** Foreign key - meeting_workspaces document */ meeting_workspace_id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    description: _zod.z.string(),
    status: MeetingStatusSchema,
    start_date_time: _zod.z.instanceof(Date),
    end_date_time: _zod.z.instanceof(Date),
    participants: _zod.z.array(MeetingParticipantsSchema),
    /** Foreign key - meeting_recurring_series document, set on materialized series meetings. */ recurring_series_id: _zod.z.instanceof(_bson.ObjectId).optional(),
    calendar_event: _calendarevent.CalendarEventOptionalSchema,
    video_conference: _videoconference.VideoConferenceOptionalSchema,
    dismissed_transcript_banners: _zod.z.array(_videoconference.TranscriptBannerKeySchema).optional(),
    created: _useractionrecord.UserActionRecord,
    updated: _useractionrecord.UserActionRecord
});
const MeetingsExtendedSchema = MeetingsSchema.extend({
    meeting_workspace_name: _zod.z.string()
});
const MeetingsExportSchema = MeetingsExtendedSchema.extend({
    participants: _zod.z.array(MeetingParticipantsExtendedSchema),
    agenda_items: _zod.z.array(_zod.z.object({
        name: _zod.z.string(),
        meetingStatus: _zod.z.string()
    })).optional(),
    action_items: _zod.z.array(_zod.z.object({
        name: _zod.z.string(),
        meetingStatus: _zod.z.string(),
        participants: _zod.z.array(_zod.z.object({
            user_id: _zod.z.instanceof(_bson.ObjectId),
            role: _zod.z.string(),
            name: _zod.z.string()
        }))
    })).optional(),
    notes: _zod.z.array(_zod.z.object({
        content: _zod.z.string(),
        visibility: _zod.z.string(),
        participants: _zod.z.array(_zod.z.object({
            user_id: _zod.z.instanceof(_bson.ObjectId),
            role: _zod.z.string(),
            name: _zod.z.string()
        }))
    })).optional()
});
